import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'gatsby';

import RouteNames from '../../routers/RouteNames';
import './Footer.scss';

const Footer = () => (
  <footer className="footer">
    <div className="footer-right">
      <a href="https://www.linkedin.com/in/dandp/">
        <FontAwesomeIcon icon={faLinkedin} />
      </a>
      <Link to={RouteNames.Contact} className="footer-link">
        <FontAwesomeIcon icon={faEnvelope} />
      </Link>
    </div>

    <div className="footer-left">
      <p className="footer-links">
        <Link to={RouteNames.Home} className="link-1 footer-link">
          Home
        </Link>
        <Link to={RouteNames.Blog} className="footer-link">
          Blog
        </Link>
        <Link to={RouteNames.Contact} className="footer-link">
          Contact
        </Link>
      </p>
      <p>Vicente De Paz &copy; {new Date().getFullYear()}</p>
    </div>
  </footer>
);

export default Footer;
